<!-- 结算记录详情 -->
<template>
  <div class="main">
    <div class="content" :class="!isEntry ? 'no-entry': ''">
        <van-image class="img"
            src="/image/detail/logo.png"
        />
        <div class="rewordImg">
            <svg
                class="icon "
                aria-hidden="true"
            >
                <use xlink:href="#icon42jiesuanjiluxiangqing"></use>
            </svg>
        </div>
        <div class="item" v-for="item in recordList"
            :key="item.name"
        >
            <div class="left">{{ item.name }}</div>
            <div class="right">{{ recordInfo[item.key] }}</div>
        </div>
        <vanImage class="recordImg" src="/image/detail/settle.png" />
    </div>
    <div class="foot-title-box">
      <div class="foot-title">
        {{ $t('app.title.footTitle') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Image as vanImage } from 'vant'
import { apiGet } from '@/services'
export default {
  name: 'settle-record',
  components: { vanImage },
  data() {
    return {
        isEntry: false, // 是否入账，默认为未入账
        recordInfo: {},
        recordList: [
            {
                name: '结算日期：',
                key: 'settlementDate'
            },
            {
                name: '结算金额：',
                key: 'settleAmount'
            },
            {
                name: '结算方式：',
                key: 'settleMethod'
            },
            {
                name: '收款卡号：',
                key: 'bankCard'
            },
            {
                name: '收款银行：',
                key: 'bankName'
            },
            {
                name: '收款名称：',
                key: 'bankAccountName'
            }
        ]
    }
  },
  created() {
    this.getSettleRecord()
  },
  methods: {
    // 获取结算记录详情
    getSettleRecord() {
      // 获取奖励详情数据
      const data = {
        settlementDate: this.$route.params.settlementDate
      }
      apiGet('partner/open/settle/record/detail', data).then(res => {
        if (res.code === '0000') {
          this.isEntry = res.data.status === 1
          this.recordInfo = res.data
        } else {
          this.$handleErr(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.main{
    width:100%;
    min-height:100%;
    background: #121212;
    padding: 0 16px;
    padding-top: 24px;
    box-sizing: border-box;
    .content{
        position: relative;
        width:343px;
        background: #282830;
        border-radius:4px;
        margin-bottom: 20px;
        padding-bottom: 75px;
        &.no-entry{
            padding-bottom: 0;
        }
        .img{
            width: 108px;
            height: 36px;
            margin: 19px 0;
        }
        .rewordImg{
            color: rgba(255,255,255,0.86);
            margin: 0 auto;
            margin-bottom: 34px;
            width: 243px;
            height: 54px;
            text-align: center;
            svg{
                width: 100%;
                height: 100%;
            }
        }
        .item{
            display: flex;
            justify-content: space-between;
            padding: 0 44px 20px;
            &.col{
                display: flex;
                flex-direction: column;
            }
            .left{
                height:21px;
                font-size:14px;
                font-weight:500;
                color: rgba(255,255,255,0.60);
                line-height:21px;
            }
            .right{
                height:21px;
                font-size:15px;
                font-weight:bold;
                color: rgba(255,255,255,0.86);
                line-height:21px;
                &.active{
                    font-size:15px;
                    font-weight:bold;
                    color:rgba(255,176,72,1);
                }
            }
        }
        .recordImg{
            position:absolute;
            width: 126px;
            height: 100px;
            right: 0;
            bottom: -17px;
        }
    }
    .foot-title-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .foot-title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size:13px;
      color: rgba(255, 255, 255, 0.6);
      &::after, &::before {
        content: '';
        display: block;
        width:32px;
        height:1px;
        background:linear-gradient(270deg,rgba(238,238,238,0) 0%,rgba(216,216,216,1) 100%);
        opacity:0.3;
        margin-left: 8px;
      }
      &::before {
        margin: 0;
        margin-right: 8px;
        transform: rotateY(180deg);
      }
    }
  }
}
</style>
